import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NpHomePageReviewsSection"] */ "/vercel/path1/src/components/home/NpHomePageReviewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NpHomePageTabsSection"] */ "/vercel/path1/src/components/home/NpHomePageTabsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/components/np-design/components/NpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NpScrollButton"] */ "/vercel/path1/src/components/np-design/components/NpHeroSectionScrollButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NpStaticTooltipLayer"] */ "/vercel/path1/src/components/np-design/sections/image/NpStaticTooltipLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdcellHomeTag"] */ "/vercel/path1/src/integrations/adcell/AdcellHomeTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["posthogBrowser","captureException"] */ "/vercel/path1/src/integrations/posthog/client-browser.ts");
